<div class="order-status" [style.--color]="brandColor">
  <div class="status-row" [class.canceled]="status === StatusEnum.Cancelled || isFailedStatus">
    <div *ngIf="statusText" class="status">
      <div
        class="status-icon"
        [class.animated]="vehicleTypeAnimation"
        *ngIf="
          status === StatusEnum.OnItsWay && (vehicleTypeIcon || vehicleTypeAnimation) && !orderDetails.delayedInTransit
        ">
        <img *ngIf="vehicleTypeIcon" [src]="'assets/' + vehicleTypeIcon + '.svg'" alt="vehicle type" />
        <common-animated-svg
          *ngIf="vehicleTypeAnimation"
          [svgName]="vehicleTypeAnimation"
          [loop]="true"
          [height]="42"
          [width]="42"></common-animated-svg>
      </div>
      <div class="status-icon" *ngIf="status === StatusEnum.Cancelled || isFailedStatus">
        <img src="assets/red-circeled-x.svg" alt="cancelled" />
      </div>
      <div class="status-text">
        {{ statusText }}
      </div>
    </div>
    <div class="order-id" *ngIf="externalOrderId">Order ID: {{ externalOrderId }}</div>
  </div>
  <button
    *ngIf="isFailedStatus && showRebookButton"
    class="rebook-failed-button"
    trackable="{{ contained ? 'Settings/' : '' }}Tracking page/{{ status }}/Suggest new delivery time"
    type="button"
    [disabled]="disableRebookButton"
    (click)="onShowRebookFlow()">
    Suggest new delivery time
  </button>
  <div
    *ngIf="status !== StatusEnum.Cancelled && status && !isFailedStatus && status !== StatusEnum.Reassigning"
    class="status-progress">
    <div
      class="progress-line"
      [class.alert]="alertProgressBar"
      [class.completed]="
        status === StatusEnum.Ordered ||
        status === StatusEnum.OnItsWay ||
        status === StatusEnum.DeliveredToCollectionPoint ||
        isFailedStatus ||
        isCompletedStatus ||
        status === StatusEnum.ReceivedAtCollectionPoint
      "></div>
    <div
      class="progress-line"
      [class.current]="
        (status === StatusEnum.OnItsWay && !orderDetails.delayedInTransit) ||
        status === StatusEnum.DeliveredToCollectionPoint
      "
      [class.completed]="
        (status === StatusEnum.OnItsWay && !orderDetails.delayedInTransit) || isFailedStatus || isCompletedStatus
      "></div>
    <div class="progress-line" [class.completed]="isCompletedStatus"></div>
  </div>
  <common-addison-lee-banner *ngIf="orderDetails.isPremium"></common-addison-lee-banner>
  <div
    class="delivery-details"
    [class.desktop]="!mobileMode"
    *ngIf="!isFailedStatus || (isFailedStatus && !showRebookButton)">
    <div class="delivery-time">
      <ng-container
        *ngIf="
          (status === StatusEnum.Ordered ||
            status === StatusEnum.OnItsWay ||
            status === StatusEnum.ReceivedAtCollectionPoint) &&
          !orderDetails.delayedInTransit
        ">
        <div class="delivery-time-title" *ngIf="deliveryTimeTitle">
          {{ deliveryTimeTitle }}
          <span *ngIf="orderDetails?.editInfo?.editFields?.includes(EditField.DeliveryDateAndTime)" id="updated-badge"
            >Edited</span
          >
        </div>
        <div class="delivery-time-value">
          <span [innerHTML]="this.dropoffTimeText"></span>
        </div>
        <ng-container *ngIf="nativeTrackingUrl">
          <common-make-changes
            [brandColor]="brandColor"
            [textColor]="textColor"
            [fontWeight]="editCtaFontWeight"
            [nativeTrackingUrl]="nativeTrackingUrl"
            [isFinalStatus]="false">
          </common-make-changes>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="orderDetails.delayedInTransit">
        <div class="waiting-note">Waiting for updates</div>
        <div class="waiting-note-secondary">We'll update you once your order is on its way</div>
        <ng-container *ngIf="nativeTrackingUrl">
          <common-make-changes
            [brandColor]="brandColor"
            [textColor]="textColor"
            [fontWeight]="editCtaFontWeight"
            [nativeTrackingUrl]="nativeTrackingUrl"
            [isFinalStatus]="false"
            [linkTextOverride]="'See additional tracking info'">
          </common-make-changes>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="status === StatusEnum.DeliveredToCollectionPoint">
        <div class="waiting-note">Please collect your order from the access point</div>
        <ng-container *ngIf="nativeTrackingUrl">
          <common-make-changes
            [brandColor]="brandColor"
            [textColor]="textColor"
            [fontWeight]="editCtaFontWeight"
            [nativeTrackingUrl]="nativeTrackingUrl"
            [isFinalStatus]="false"
            [linkTextOverride]="'See additional tracking info'">
          </common-make-changes>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="isCompletedStatus">
        <div class="delivered-details delivered-details--time" [innerHTML]="statusUpdateTimeText"></div>
        <div class="delivered-details delivered-details--address">{{ this.addressLine1 }}</div>
        <div
          *ngIf="addressLine2"
          class="delivered-details delivered-details--address delivered-details--address--line2">
          {{ this.addressLine2 }}
        </div>
        <ng-container *ngIf="nativeTrackingUrl">
          <common-make-changes
            [brandColor]="brandColor"
            [textColor]="textColor"
            [fontWeight]="editCtaFontWeight"
            [nativeTrackingUrl]="nativeTrackingUrl"
            [isFinalStatus]="true">
          </common-make-changes>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="status === StatusEnum.Reassigning">
        <div class="waiting-note">Preparing for dispatch</div>
        <div class="waiting-note-secondary">We'll update you once your order is on its way</div>
      </ng-container>
      <ng-container *ngIf="status === StatusEnum.Cancelled || (isFailedStatus && !showRebookButton)">
        <div class="delivered-details delivered-details--failed">
          {{ merchantName ? 'For more details please contact ' + merchantName : 'For more details please contact us' }}
        </div>
        <div class="contact-methods" [class.desktop]="!mobileMode">
          <a
            *ngIf="merchantEmail"
            class="method-button"
            [href]="'mailto:' + merchantEmail"
            trackable="{{ contained ? 'Settings/' : '' }}Tracking page/{{ status }}/Contact merchant email">
            <common-email-icon [color]="brandColor"></common-email-icon>
            {{ mobileMode ? 'Email' : merchantEmail }}
          </a>
          <a
            *ngIf="merchantPhone"
            class="method-button phone"
            [href]="'tel:' + merchantPhone"
            trackable="{{ contained ? 'Settings/' : '' }}Tracking page/{{ status }}/Contact merchant phone">
            <common-phone-icon [color]="mobileMode ? brandColor : '#343E57'"></common-phone-icon>
            {{ mobileMode ? 'Call' : merchantPhone }}
          </a>
        </div>
      </ng-container>
    </div>
    <ng-container *ngIf="shouldShowDriverPhone" [ngTemplateOutlet]="driverPhone"></ng-container>
  </div>

  <div
    class="committed-time-info-block"
    *ngIf="commitedDropoffTime && dropoffWindowType !== TrackingDropoffWindowType.Express">
    <img src="assets/info-thin.svg" />
    <span>{{ commitedDropoffTime }}</span>
  </div>

  <div
    *ngIf="status === StatusEnum.OnItsWay && shouldShowContactDriverMessage && courierPhone"
    class="courier-contact-message"
    [class.mobile]="mobileMode">
    <div class="contact-message">
      <div class="title">Not going to be home?</div>
      <div class="description"><b>Please call</b> your driver to coordinate delivery instructions.</div>
    </div>
    <ng-container *ngIf="courierPhone" [ngTemplateOutlet]="driverPhone"></ng-container>
  </div>
  <div *ngIf="isGreen && !isFailedStatus && status !== StatusEnum.Cancelled" id="carbon-neutral-delivery">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <mask
        id="mask0_6134_16809"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6134_16809)">
        <path
          d="M4.22917 15.7708C4.07639 15.6181 4.00347 15.441 4.01042 15.2396C4.01736 15.0382 4.09028 14.8611 4.22917 14.7083L5.25 13.6667C4.84722 13.1528 4.53819 12.5903 4.32292 11.9792C4.10764 11.3681 4 10.7083 4 10C4 8.33333 4.58333 6.91667 5.75 5.75C6.91667 4.58333 8.33333 4 10 4H16V10C16 11.6806 15.4167 13.1007 14.25 14.2604C13.0833 15.4201 11.6667 16 10 16C9.29167 16 8.62847 15.8889 8.01042 15.6667C7.39236 15.4444 6.82639 15.1319 6.3125 14.7292L5.27083 15.7708C5.11806 15.9236 4.94097 15.9965 4.73958 15.9896C4.53819 15.9826 4.36806 15.9097 4.22917 15.7708ZM7.27083 12.7292C7.42361 12.8819 7.59722 12.9583 7.79167 12.9583C7.98611 12.9583 8.15972 12.8819 8.3125 12.7292L11.7708 9.27083C11.9236 9.11806 12 8.94097 12 8.73958C12 8.53819 11.9236 8.36111 11.7708 8.20833C11.6181 8.05556 11.4444 7.97917 11.25 7.97917C11.0556 7.97917 10.8819 8.05556 10.7292 8.20833L7.27083 11.6667C7.11806 11.8194 7.04167 11.9965 7.04167 12.1979C7.04167 12.3993 7.11806 12.5764 7.27083 12.7292Z"
          fill="#05DE76" />
      </g>
    </svg>
    <span>Carbon neutral delivery</span>
  </div>
  <div
    class="external-link-row"
    *ngIf="
      orderDetails?.originAddress?.type === AddressType.Pudo &&
      this.orderDetails.tokenType === TokenTypeEnum.Sender &&
      this.status === StatusEnum.Ordered &&
      !this.isExternalPickup
    ">
    <a class="link" target="_blank" [href]="collectionPointsLink">Find your nearby collection point</a>
    <common-external-link-icon></common-external-link-icon>
  </div>
</div>
<button
  id="edit-order-button"
  *ngIf="showEditOrderButton"
  [style.--color]="brandColor"
  [style.--text-color]="textColor"
  [style.--font-weight]="editCtaFontWeight"
  type="button"
  (click)="openEditOrderPanel()"
  trackable="{{ contained ? 'Settings/' : '' }}Tracking page/{{ status }}/ Make changes to this delivery">
  Make changes to this delivery
</button>

<span class="eta-note" *ngIf="commitedDropoffTime">*Arrival time is subject to change</span>

<ng-template #driverPhone>
  <div *ngIf="!mobileMode" class="desktop-phone">
    <common-phone-icon class="phone-icon" [color]="'#343E57'"></common-phone-icon>
    {{ courierPhone }}
  </div>
  <div *ngIf="mobileMode" class="mobile-phone">
    <a
      [href]="'tel:' + courierPhone"
      trackable="{{ contained ? 'Settings/' : '' }}Tracking page/{{ status }}/Contact driver phone">
      <common-phone-icon [color]="textColor"></common-phone-icon>
    </a>
  </div>
</ng-template>
